import { styled as v } from "@mui/material";
import y from "../../../assets/icons/icon-blank.svg.js";
import z from "../generic/AnimatedBox.js";
import { DEFAULT_ANIMATE_DURATION as V, DEFAULT_ALT as _ } from "../../../constants/layout.js";
import j from "next/image";
import { useState as r, useCallback as s, useEffect as B } from "react";
import { getImageVariants as C, selectImageVariant as F } from "./responsiveImage.js";
import { jsx as L } from "react/jsx-runtime";
const H = v(j)`
  object-fit: contain;
`, R = v(z)`
  position: relative;
`, S = (n) => {
  var a;
  return ((a = n == null ? void 0 : n.src) == null ? void 0 : a.indexOf("data:image/gif;base64")) < 0;
}, Z = (n) => {
  const {
    alt: a = _,
    className: w,
    extraSrc: e,
    fallbackUrl: m = y,
    isDisable: f,
    loading: E = void 0,
    src: l,
    onAnimationEnd: O,
    ...i
  } = n, [u, t] = r(l), [h, p] = r(!1), [g, I] = r(!1), [b, A] = r(!0), D = s(() => {
    p(!0);
  }, []), M = s(() => {
    p(!1);
  }, []), k = s(() => {
    I(!0);
  }, []), x = s(() => {
    I(!1);
  }, []), o = C(u), P = s(({
    src: d,
    width: c
  }) => o != null && o.length ? F(o, c) : d, [o]), T = s(() => {
    t(m);
  }, [m]), U = s((d) => {
    const c = d.target;
    S(c) && A(!0);
  }, []), N = {
    ...e != null && e.hover ? {
      onMouseEnter: D,
      onMouseLeave: M
    } : {},
    ...e != null && e.pressed ? {
      onMouseDown: k,
      onMouseUp: x
    } : {}
  };
  return B(() => {
    e ? e.disable && f ? t(e.disable) : e.hover && h ? t(e.hover) : e.pressed && g && t(e.pressed) : t(l);
  }, [e, f, h, g, l]), /* @__PURE__ */ L(R, {
    className: w,
    in: b,
    timeout: V,
    onAnimationEnd: O,
    ...N,
    children: /* @__PURE__ */ L(H, {
      alt: a,
      fill: i.width == null && i.height == null,
      loading: E ? "lazy" : void 0,
      sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw",
      src: u || "",
      loader: P,
      unoptimized: !(o != null && o.length) && !i.loader,
      onError: T,
      onLoad: U,
      ...i
    })
  });
};
export {
  Z as default
};
//# sourceMappingURL=Image.js.map
